import { render } from "./BetSlipMain.vue?vue&type=template&id=65cd200d&scoped=true"
import script from "./BetSlipMain.vue?vue&type=script&lang=js"
export * from "./BetSlipMain.vue?vue&type=script&lang=js"

import "./BetSlipMain.vue?vue&type=style&index=0&id=65cd200d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cd200d"]])

export default __exports__